import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { RADA_RUTAS } from '../rada.constants';
import { esUsuarioSoloTv } from './rada-permisos';

/**
 * Lleva al usuario de TV (R7.1, R9.3) directo al Modo pantalla: si el árbol de permisos del login
 * contiene solo `RADA_TV_VER` redirige a `rada/modo-pantalla`, que está fuera del shell; cualquier
 * otro usuario sigue su camino sin cambios. Va después de `authGuard` en la ruta raíz del shell,
 * así también devuelve al modo pantalla a quien navegue a mano a otra ruta del shell (15.2).
 * Enganchado en `app.routes.ts` con la aprobación del DLF (D3, PM 2026-10-29; R9.3, D-123).
 */
export const radaTvHomeGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return esUsuarioSoloTv(auth.permisos()) ? router.parseUrl(RADA_RUTAS.MODO_PANTALLA) : true;
};
